import React from 'react';
import classNames from 'classnames';
import styles from './article-pagination.module.scss';
import ArticlePreview from '../article-preview/article-preview.component';
import { ArticlePaginationInterface } from './article-pagination.interface';
import { ArticlePreviewSideEnum } from '../article-preview/article-preview.interface';
import { ArrowIcon } from '../../icons';

const ArticlePagination: React.FunctionComponent<ArticlePaginationInterface> = ({
  className,
  onPrev,
  onNext,
  prevArticle: {
    className: prevClassName,
    children: prevChildren,
    ...prevArticle
  },
  nextArticle: {
    className: nextClassName,
    children: nextChildren,
    ...nextArticle
  },
}) => {
  return (
    <div className={classNames(
      styles.component,
      className,
    )}>
      <ArticlePreview
        {...prevArticle}
        className={classNames(
          styles.item,
          styles.prev,
          prevClassName,
          styles.isLeft,
        )}
        onClick={onPrev}
        imageSide={ArticlePreviewSideEnum.LEFT}
      >
        {prevChildren}

        <ArrowIcon className={styles.arrow} />
      </ArticlePreview>

      <hr className={styles.devider} />

      <ArticlePreview
        className={classNames(
          styles.item,
          styles.next,
          nextClassName,
          styles.isRight,
        )}
        {...nextArticle}
        onClick={onNext}
      >
        {nextChildren}

        <ArrowIcon className={styles.arrow} />
      </ArticlePreview>
    </div>
  );
};

export default ArticlePagination;
